import React from 'react';
import { List } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash';
import { datasetUrl } from '@/constants/urls';
import { resolveRequestWorkflow } from '../../state/state';

const RequestDatasetListItem = ({
  datasetCode,
  name,
  link,
}) => (
  <List.Item className="aridhia-request-dataset-list-item">
    <List.Header>
      <FormattedMessage id="request.list.dataset.title" />
    </List.Header>
    {link && (
      <List.Description className="aridhia-form-item-description">
        <Link to={datasetUrl({ code: datasetCode })} title={name}>
          {name}
        </Link>
      </List.Description>
    )}
    {!link && (<List.Description className="aridhia-form-item-description" content={name} />)}
  </List.Item>
);

const mapStateToProps = ({
  requests: { requests },
  workflows: { workflows },
}, ownProps) => {
  const { request } = resolveRequestWorkflow(requests, workflows, ownProps);
  const { code, catalogue } = get(request, 'datasets[0]', { code: '', catalogue: { title: '' } });

  return ({ datasetCode: code, name: catalogue.title });
};

export default connect(mapStateToProps)(RequestDatasetListItem);
